import { useEffect, useState } from 'react';

import { gql, useQuery } from '@apollo/client';

export const GET_EMPLOYEE_QUESTIONNAIRES_FOR_TABLE = gql`
  query getOpenQuestionnaires($filter: FilterQuestionnaireInput, $queryOptions: QueryOptionsInput) {
    getOpenQuestionnaires(filter: $filter, queryOptions: $queryOptions) {
      collection {
        _id
        createdBy
        status
        createdAt
        companyId
        employeePersonalInfo {
          firstName
          lastName
        }
        company {
          module
          name
          _id
          locations {
            name
          }
        }
        department {
          name
        }
        job {
          title
          _id
        }
        jobLocation {
          createdBy
          companyLocation {
            name
          }
          _id
        }
        applicantId
        applicant {
          _id
        }
        jobSupervisors {
          _id
          supervisorJobTitle
          supervisorMember {
            _id
            profile {
              displayName
            }
          }
        }
        responsiblePersonsIds
        responsiblePersons {
          _id
          profile {
            displayName
          }
        }
      }
      totalCount
    }
  }
`;

export const useGetOpenQuestionnairesForTable = ({
  searchParam,
  filter,
}: {
  searchParam: string;
  filter: any;
}) => {
  const [currentPage, setPage] = useState(1);
  const [currentNameSort, setNameSort] = useState<{ field: string; sortBy: number }[]>();

  const pageSize = 12;
  const { data, loading } = useQuery(GET_EMPLOYEE_QUESTIONNAIRES_FOR_TABLE, {
    variables: {
      queryOptions: {
        limit: pageSize,
        skip: pageSize * currentPage - pageSize,
        sort: currentNameSort,
      },
      filter: {
        companyId: filter.companyId,
        companiesFilter: filter.companyFilter,
        searchParam,
      },
    },
    skip: !filter.companyId,
    fetchPolicy: 'network-only',
  });

  const { totalCount = 0, collection = [] } = data?.getOpenQuestionnaires || {};

  useEffect(() => setPage(1), [searchParam]);

  return {
    loading,
    employees: collection,
    paginationConfig: {
      total: totalCount,
      pageSize,
      current: currentPage,
      onChange: (page: number) => setPage(page),
    },
    onTableChange: (a: any, b: any, order: any) => {
      if (order) {
        const sortBy = order === 'ascend' ? 1 : -1;

        setNameSort([{ field: 'name', sortBy }]);
      }
    },
  };
};
